import orderProjectRoute from "./orderProject";

/**
 * Created by likai on 2018/12/01
 * Desc: 订单项目售后模块路由表配置
 * 
 */
const _import = require('./_import_' + process.env.NODE_ENV);
const afterSaleRouter = [
  //申请售后
  {
    path: '/refundFn',
    name: 'refundFn',
    component: _import('afterSaleProject/refundFn/index'),
    hidden: true,
    title: '申请售后',
    meta: { title: '申请售后' }
  },
  {
    path: '/afterSaleList',
    component: _import('afterSaleProject/afterSaleList/index'),
    hidden: true,
    title: '售后退款',
    meta: { title: '售后退款' }
  },
  {
    path: '/AfterSale',
    component: _import('afterSaleProject/AfterSale/index'),
    hidden: true,
    title: '售后详情',
    meta: { title: '售后详情' }
  },
  {
    path: '/refundsRule',
    component: _import('afterSaleProject/refundsRule/index'),
    hidden: true,
    title: '售后规则',
    meta: { title: '售后规则' }
  },
  {
    path: '/refundType',
    component: _import('afterSaleProject/refundType/index'),
    hidden: true,
    title: '选择售后方式',
    meta: { title: '选择售后方式' }
  },
  {
    path: '/refundProgress',
    component: _import('afterSaleProject/refundProgress/index'),
    hidden: true,
    title: '售后进度',
    meta: { title: '售后进度' }
  },
  {
    path: '/logistics',
    component: _import('afterSaleProject/logistics/index'),
    hidden: true,
    title: '填写物流信息',
    meta: { title: '填写物流信息' }
  },
  {
    path: '/logisticsList',
    component: _import('afterSaleProject/logisticsList/index'),
    hidden: true,
    title: '物流公司列表',
    meta: { title: '物流公司列表' }
  },
  {
    path: '/applyAfterSale',
    component: _import('afterSaleProject/applyAfterSale/index'),
    hidden: true,
    title: '申请售后',
    meta: { title: '申请售后' }
  },
  {
    path: '/refundment',
    name:'refundment',
    component: _import('afterSaleProject/refundment/index'),
    hidden: true,
    title: '退款说明',
    meta:{title:'退款说明'}
  }
];
export default afterSaleRouter;



// WEBPACK FOOTER //
// ./src/router/afterSale.js